import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.ikarascents.com';
const OG_IMAGE = 'https://images.unsplash.com/photo-1714636608872-048fc9231892?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200';

const SEO_DATA = {
  home: {
    title: 'Ikara Scents | Signature Fragrance Oils & Diffusers for Commercial Spaces',
    description: "India's premium space fragrance brand. Signature oils and diffusion systems for hotels, spas, restaurants, corporate offices and luxury residences.",
    path: '/'
  },
  products: {
    title: 'Fragrance Oils & Diffuser Machines | Ikara Scents',
    description: 'Explore 28 signature fragrance oils curated for 9 commercial space categories. From Spa & Wellness to Hotels, Restaurants and Corporate Offices.',
    path: '/products'
  },
  about: {
    title: 'About Ikara Scents | Made in India Premium Space Fragrances',
    description: "Ikara Scents creates signature fragrance experiences for India's finest commercial spaces. 100% Vegan, 100% Organic, Made in India.",
    path: '/about'
  },
  contact: {
    title: 'Enquire Now | Ikara Scents',
    description: 'Get in touch with the Ikara Scents team for fragrance consultations, bulk orders and diffuser machine enquiries for your commercial space.',
    path: '/contact'
  }
};

export const PageSEO = ({ page }) => {
  const seo = SEO_DATA[page];
  const canonicalUrl = `${SITE_URL}${seo.path}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:site_name" content="Ikara Scents" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={seo.title} />
      <meta property="twitter:description" content={seo.description} />
      <meta property="twitter:image" content={OG_IMAGE} />
      
      {/* WhatsApp */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  );
};

// Organization Schema for Homepage
export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Ikara Scents",
    "description": "India's premium space fragrance brand. Signature oils and diffusion systems for hotels, spas, restaurants, corporate offices and luxury residences.",
    "url": SITE_URL,
    "logo": `${SITE_URL}/logo.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-8527499057",
      "contactType": "sales",
      "email": "hello@ikarascents.com",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    },
    "address": [
      {
        "@type": "PostalAddress",
        "streetAddress": "B-72, Ashoka Enclave II, Sector 37",
        "addressLocality": "Faridabad",
        "addressRegion": "Delhi NCR",
        "postalCode": "121003",
        "addressCountry": "IN"
      },
      {
        "@type": "PostalAddress",
        "streetAddress": "Platinum Plaza, PU 4, Behind C21 Mall, AB Road",
        "addressLocality": "Indore",
        "addressRegion": "Madhya Pradesh",
        "postalCode": "452010",
        "addressCountry": "IN"
      }
    ],
    "sameAs": [
      "https://instagram.com/ikarascents"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

// Product Schema for fragrance oils
export const ProductSchema = ({ name, notes }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": `Ikara ${name} Fragrance Oil`,
    "description": `${name} - Premium fragrance oil with notes of ${notes}. Ideal for commercial space scenting.`,
    "brand": {
      "@type": "Brand",
      "name": "Ikara Scents"
    },
    "manufacturer": {
      "@type": "Organization",
      "name": "Ikara Scents"
    },
    "category": "Fragrance Oils",
    "material": "100% Vegan, Organic",
    "countryOfOrigin": "India"
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default PageSEO;
